import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { InputIconsRenderer } from '../common';
import { Input } from './Input';
const replaceCommas = (value) => value.replace(',', '.').replace(/,/g, '');
const createFloatRegExp = (decimalPlaces) => {
    const decimalPlacesCountPart = decimalPlaces === undefined ? '*' : `{0,${decimalPlaces}}`;
    return new RegExp(`^\\d*[.,]?\\d${decimalPlacesCountPart}$`);
};
const isChangeAllowed = (value, floatOnly, intOnly, regexp, decimalPlaces) => {
    if (intOnly && !/^\d*$/.test(value)) {
        return false;
    }
    if (floatOnly) {
        const floatOnlyRegExp = createFloatRegExp(decimalPlaces);
        return floatOnlyRegExp.test(value);
    }
    if (regexp && value.length !== 0) {
        return new RegExp(regexp).test(value);
    }
    return true;
};
export const InputRenderer = memo(forwardRef(function InputRenderer({ iconStart, iconEnd, intOnly, floatOnly, regexp, onChange, decimalPlaces, ...inputProps }, ref) {
    const handleChange = useCallbackRef((e) => {
        if (isChangeAllowed(e.currentTarget.value, floatOnly, intOnly, regexp, decimalPlaces)) {
            const { value } = e.currentTarget;
            e.currentTarget.value = floatOnly ? replaceCommas(value) : value;
            onChange?.(e);
        }
    });
    return (_jsx(InputIconsRenderer, { iconStart: iconStart, iconEnd: iconEnd, children: _jsx(Input, { ref: ref, ...inputProps, onChange: handleChange }) }));
}));
